import RouterMixin from "@/assets/plugins/mps-common/router/RouterMixin";

export default {

    install(Vue, options) {
        Vue.mixin(RouterMixin);
    }

}